import AdminUserList from '@/pages/AdminUserList.vue';
import AdminUserList2 from '@/pages/AdminUserList2.vue';
import AdminSuppliersPage from '@/pages/AdminSuppliersPage.vue';
import UserAdminDetailPage from '../../pages/user/UserAdminDetailPage.vue';
import AdminDetailPage from '../../pages/AdminDetailPage.vue';
import AdminMaterialCategories from '@/pages/AdminMaterialCategories.vue';

export default [
  {
    path: '/admin/users2',
    name: 'admin-users2',
    component: AdminUserList,
  },
  {
    path: '/admin/users',
    name: 'admin-users',
    component: AdminUserList2,
  },
  {
    path: '/admin/users2/:userId',
    name: 'admin-user-detail2',
    component: AdminDetailPage,
  },
  {
    path: '/admin/users/:userId/:tab',
    name: 'admin-user-detail',
    component: UserAdminDetailPage,
  },
  {
    path: '/admin/material-categories',
    name: 'admin-material-categories',
    component: AdminMaterialCategories,
  },
  // (Claude) реестр поставщиков модуля «Спецификации и комплектация» (ТЗ 6.7)
  {
    path: '/admin/suppliers',
    name: 'admin-suppliers',
    component: AdminSuppliersPage,
    meta: { title: 'Поставщики' },
  },
];
